import {
  clientActionEvent,
  ProductSectorMappingProductStateEventGenerateReport,
  ProductSectorMappingProductStateEventRollback,
  ProductSectorMappingProductStateEventSubmit
} from 'api'
import { getCurrentWindowId } from 'utils'

function createSectorMappingGenerateReport(sourceWindowId: string = getCurrentWindowId()) {
  return clientActionEvent<ProductSectorMappingProductStateEventGenerateReport>(
    'ProductSectorMappingProductStateEventGenerateReport',
    { id: 'default' },
    sourceWindowId
  )
}

function createSectorMappingDiscard(sourceWindowId: string = getCurrentWindowId()) {
  return clientActionEvent<ProductSectorMappingProductStateEventRollback>(
    'ProductSectorMappingProductStateEventRollback',
    { id: 'default' },
    sourceWindowId
  )
}

function createSectorMappingCommit(sourceWindowId: string = getCurrentWindowId()) {
  return clientActionEvent<ProductSectorMappingProductStateEventSubmit>(
    'ProductSectorMappingProductStateEventSubmit',
    { id: 'default' },
    sourceWindowId
  )
}

export const ProductSectorMappingActions = {
  generateReport: createSectorMappingGenerateReport,
  discard: createSectorMappingDiscard,
  commit: createSectorMappingCommit
}
